import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useUser } from './context/userContext';
import Footer from './components/Footer';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import DataUsage from './pages/DataUsage';
import BuildingSelector from './pages/BuildingSelector';

const App: React.FC = () => {
  const { isLoggedIn } = useUser();
  return (
    <Router>
      <div className="container">
        <Routes>
          <Route path="/" element={isLoggedIn ? <BuildingSelector /> : <LoginPage />} />
          <Route path="/dashboard" element={isLoggedIn ? <Dashboard /> : <Navigate to="/" />} />
          <Route path="/timetable" element={isLoggedIn ? <Settings /> : <Navigate to="/" />} />
          <Route path="/data" element={isLoggedIn ? <DataUsage /> : <Navigate to="/" />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
};

export default App;
